export function isLatestProductionHost(hostname: string): boolean {
  return hostname.toLowerCase() === 'latest.pinpointedu.com';
}
